// extracted by mini-css-extract-plugin
export var layoutWrapper = "Layout-module--layout-wrapper--1NHEY";